// TIJDELIJKE stockfoto's (Unsplash-licentie). Vervangen door eigen LevelLeven-fotografie.
const u = (id) => (w) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=72`;

export const PHOTOS = {
  hero: { src: u("photo-1590650046871-92c887180603"), alt: "Vier vrouwen in een warm gesprek aan een tafel, ze lachen samen", temp: true },
  uitzicht: { src: u("photo-1484627147104-f5197bcd6651"), alt: "Iemand zit op een rots en kijkt uit over de bergen bij zonsondergang", temp: true },
  gesprek: { src: u("photo-1542338332-76971ae8c292"), alt: "Twee mensen in gesprek aan tafel, met koffie", temp: true },
  pad: { src: u("photo-1723227123897-0624fe046ae8"), alt: "Een houten wandelpad slingert door een groene vallei", temp: true },
};

export function Photo({ photo, sizes = "100vw", widths = [480, 800, 1200, 1600], className = "", priority = false }) {
  return (
    <img
      src={photo.src(widths[1])}
      srcSet={widths.map((w) => `${photo.src(w)} ${w}w`).join(", ")}
      sizes={sizes}
      alt={photo.alt}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : undefined}
      decoding="async"
      className={`object-cover ${className}`}
      data-temp-photo={photo.temp ? "true" : undefined}
    />
  );
}
